module.exports = __webpack_public_path__ + "img/categorie-cave-famille-boutrais.c9eecbf1.webp";